import React from "react";
import Flagship from "../../core/flagship";
import { Segment, Button } from "semantic-ui-react";
import CommentBox from "./CommentBox";

class SingleRecordHistory extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = this.getInitialState();
    this.refreshFeed = this.refreshFeed.bind(this);
    this.nextPage = this.nextPage.bind(this);
    this.prevPage = this.prevPage.bind(this);
    this.renderPagination = this.renderPagination.bind(this);
  }

  getInitialState() {
    return {
      offset: 0,
      items: [],
      error: "",
      loading: false,
    };
  }

  componentDidMount() {
    this.refreshFeed();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.instance !== this.props.instance && nextProps.userId !== 0) {
      this.refreshFeed();
    }
  }

  nextPage() {
    let newOffset = this.state.offset + 5;
    this.setState({
      offset: newOffset,
    });
    this.getFeedItems(newOffset);
  }

  prevPage() {
    let newOffset = this.state.offset - 5;
    if (newOffset < 0) {
      newOffset = 0;
    }
    this.setState({
      offset: newOffset,
    });
    this.getFeedItems(newOffset);
  }

  getFeedItems(offset) {
    this.setState({
      loading: true,
    });
    let self = this;

    Flagship.get(
      "log/read",
      {
        offset,
        target: self.props.recordId,
        count: 20,
      },
      function (response) {
        if (response.data.success === true) {
          self.setState({
            items: response.data.results,
            loading: false,
          });
        } else {
          self.setState({
            error: "Failed to load record history.",
            loading: false,
          });
        }
      },
      function (err) {
        console.error("ERROR: " + err);
      }
    );
  }

  refreshFeed() {
    this.getFeedItems(this.state.offset);
  }

  renderPagination() {
    if (this.state.offset > 0 && this.state.items.length === 5) {
      return (
        <Button.Group fluid className="activity-feed-pagination">
          <Button secondary onClick={this.prevPage}>
            Previous Page
          </Button>
          <Button.Or />
          <Button primary onClick={this.nextPage}>
            Next Page
          </Button>
        </Button.Group>
      );
    } else if (this.state.offset > 0) {
      return (
        <Button.Group fluid className="activity-feed-pagination">
          <Button secondary onClick={this.prevPage}>
            Previous Page
          </Button>
        </Button.Group>
      );
    } else if (this.state.items.length === 5) {
      return (
        <Button.Group fluid className="activity-feed-pagination">
          <Button primary onClick={this.nextPage}>
            Next Page
          </Button>
        </Button.Group>
      );
    } else {
      return (
        <span>
          <br />
          No{" "}
          {this.state.offset === 0 && this.state.items.length === 0
            ? null
            : "other"}{" "}
          activity to display.
        </span>
      );
    }
  }

  render() {
    return (
      <Segment className="fade-in recent-activity">
        <CommentBox
          viewMode="full"
          search={false}
          recordId={this.props.recordId}
          recordKey={this.props.recordKey}
          lineItems={this.props.lineItems}
          recordType={this.props.recordType}
          commentFilterUser={this.props.commentFilterUser}
          commentFilterSearch={this.props.commentFilterSearch}
        />
      </Segment>
    );
  }
}

export default SingleRecordHistory;



// WEBPACK FOOTER //
// ./src/components/misc/SingleRecordComments.js